import { useState, useEffect } from 'react'
import { supabaseGetter } from '~/api/supabase-getter'

export const useUserByteSize = ({ userId }) => {
  const [byteSize, setByteSize] = useState(null)
  const [userStorage, setUserStorage] = useState(null)
  const [loading, setLoading] = useState(true)
  const [error, setError] = useState(null)

  useEffect(() => {
    let isMounted = true

    if (!userId) {
      setByteSize(null)
      setUserStorage(null)
      setLoading(false)
      setError(null)
      return
    }

    async function fetchUsage() {
      if (isMounted) { setLoading(true); setError(null) }

      try {
        const [usageResult, storageResult] = await Promise.all([
          supabaseGetter.metering.getUserOrgUsage(userId),
          supabaseGetter.metering.getUserStorage(userId),
        ])

        if (usageResult.error) throw usageResult.error
        if (storageResult.error) throw storageResult.error
        if (!isMounted) return

        setByteSize(usageResult.data)
        setUserStorage(storageResult.data)
      } catch (err) {
        if (!isMounted) return
        console.error('[useUserByteSize]', err)
        setError(err.message || 'Failed to fetch usage')
        setByteSize(null)
      } finally {
        if (isMounted) setLoading(false)
      }
    }

    fetchUsage()
    return () => { isMounted = false }
  }, [userId])

  return {
    byteSize,      // raw bytes (BIGINT from Postgres)
    userStorage,   // { soft_limit_bytes, hard_limit_bytes, is_over_limit, last_calculated_at, ... }
    loading,
    error,
    invalidate: supabaseGetter.metering.invalidate,
  }
}
